import moment from 'moment';

export const formatDate = (date) => {
  return moment(date).fromNow();
};

export const formatCurrency = (value) => {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
};

export const hasCadence = (lead) => {
  return Boolean(lead.cadence && lead.cadence.length > 0);
};

export const hasValue = (lead) => {
  return Boolean(lead.value);
};

export const hasIcon = (lead) => {
  return Boolean(lead.icon);
}; 